export default {
  init() {
    $('.fancybox').fancybox();
    // JavaScript to be fired on all pages
    $(window).load(function() {
      $('body').removeClass('preload');
    });
    $().fancybox();
    $('.hamburger').click(function() {
      $(this).toggleClass('is-active');
    });
    $('.burger, .overlay').click(function(){
      $('.burger').toggleClass('clicked');
      $('.overlay').toggleClass('show');
      $('nav').toggleClass('show');
      $('body').toggleClass('overflow');
    });
    
    var header = $('#phoneOverlay');
      $(window).scroll(function() {
          var scroll = $(window).scrollTop();
          //var scrollOffset = $('#phoneOverlay').offset().top - $('#navigation-bar').offset().top;
          //console.log(scroll);
          if (scroll >= 446) {
              header.removeClass('').addClass('sticky');
          } else {
              header.removeClass('sticky').addClass('');
          }
      });

      // Dashboard jquery
      $(document).ready(function() {
        var url = window.location.href;
        var updatedUrl = url.split('?')[0];
        history.replaceState({}, document.title, updatedUrl);
      
        $('.notification .delete').each(function() {
          var $delete = $(this);
          var $notification = $delete.parent();
      
          $delete.on('click', function() {
            $notification.remove();
          });
        });
      });
      

    /*eslint-disable */
    jQuery(function($){
    	$('#filter').submit(function(){
    		var filter = $('#filter');
    		$.ajax({
    			url:filter.attr('action'),
    			data:filter.serialize(), // form data
    			type:filter.attr('method'), // POST
    			beforeSend:function(xhr){
    				filter.find('button').text('Verwerken...'); // changing the button label
    			},
    			success:function(data){
    				filter.find('button').text('filter'); // changing the button label back
    				$('#response').html(data); // insert data
    			}
    		});
    		return false;
    	});
    });

    // Lopend -> voorraad concept
    $(document).ready(function() {
      $('.change-status-ongoing').click(function(e) {
          e.preventDefault();

          var postID = $(this).data('post-id');
          var newStatus = 'draft';
          var currentTime = new Date().toISOString();

          $.ajax({
            url: '/wp-admin/admin-ajax.php',
            method: 'POST',
            data: {
                action: 'change_status',
                post_id: postID,
                new_status: newStatus,
                current_time: currentTime
            },
            success: function(response) {
              location.reload();
            },
            error: function(xhr, status, error) {
              console.error(error);
            }
        });
      });
  });

  // Voorraad concept -> gepubliceerd
  $(document).ready(function() {
    $('.change-status-publish').click(function(e) {
        e.preventDefault();

        var postID = $(this).data('post-id');
        var newStatus = 'publish';
        var currentTime = new Date().toISOString();

        $.ajax({
          url: '/wp-admin/admin-ajax.php',
          method: 'POST',
          data: {
              action: 'change_status',
              post_id: postID,
              new_status: newStatus,
              current_time: currentTime
          },
          success: function(response) {
            location.reload();
          },
          error: function(xhr, status, error) {
            console.error(error);
          }
      });
    });
  });

  // Voorraad -> verkocht
  $(document).ready(function() {
    $('.change-status').click(function(e) {
        e.preventDefault();

        var postID = $(this).data('post-id');
        var newStatus = 'verkocht';
        var currentTime = new Date().toISOString();

        $.ajax({
          url: '/wp-admin/admin-ajax.php',
          method: 'POST',
          data: {
              action: 'change_status',
              post_id: postID,
              new_status: newStatus,
              current_time: currentTime
          },
          success: function(response) {
            location.reload();
          },
          error: function(xhr, status, error) {
            console.error(error);
          }
      });
    });
  });

  $(document).ready(function() {
    $('.change-status-back').click(function(e) {
        e.preventDefault();

        var postID = $(this).data('post-id');
        var newStatus = 'publish';
        var currentTime = new Date().toISOString();

        $.ajax({
          url: '/wp-admin/admin-ajax.php',
          method: 'POST',
          data: {
              action: 'change_status',
              post_id: postID,
              new_status: newStatus,
              current_time: currentTime
          },
          success: function(response) {
            location.reload();
          },
          error: function(xhr, status, error) {
            console.error(error);
          }
      });
    });
  });

  $(document).ready(function() {
    $('.js-modal-trigger').click(function() {
      var target = $(this).data('target');
      $('#' + target).addClass('is-active');
    });

    $('.modal-close, .cancel-modal, .modal-background').click(function() {
      var modal = $(this).closest('.modal');
      modal.removeClass('is-active');
    });
  });
    /*eslint-enable */
  },

  finalize() {
     // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
